import { render, staticRenderFns } from "./PublishedTable.vue?vue&type=template&id=0b35163e&scoped=true"
import script from "./PublishedTable.vue?vue&type=script&lang=js"
export * from "./PublishedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35163e",
  null
  
)

export default component.exports